import { BROWSER_ERROR } from "@pdfking/translations/enum/errors"

export default (e: any = undefined): never => {
  if (e) console.error(e)
  throw BROWSER_ERROR
}
